<template>
  <div id="privacy-policy">
    <div class="top-nav">
      <div class="top-nav-item" :class="{ active: to === 'peer' }" @click="to = 'peer'">用户协议</div>
      <div class="top-nav-item" :class="{ active: to === 'privicy' }" @click="to = 'privicy'">隐私政策</div>
    </div>
    <div class="bottom-content">
      <div class="text-content" v-show="to === 'peer'">
        <div class="release-time">发布日期:2019年12月7日      更新时间:2020年6月4日</div>

        <div class="p-item">
          <div class="p-content">
            欢迎您使用深圳市六六六国际旅行社有限公司（以下简称“上上签”或“我们”）的服务！<br>为使用上上签网站，您应当阅读并遵守《上上签用户协议》。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议。限制、免责条款可能以黑体加粗形式提示您注意。<br>除非您已阅读并接受本协议所有条款，否则您无权使用上上签提供的服务。您使用上上签的服务即视为您已阅读并同意上述协议的约束。如用户不同意本服务协议任意内容，请勿注册或使用上上签。如用户通过进入注册程序或登录账号，即表示用户与上上签已达成协议，自愿接受本服务协议的所有内容。此后，用户不得以未阅读本服务协议内容作任何形式的抗辩。<br>如果您未满18周岁，请在法定监护人的陪同下阅读本协议并决定是否同意接受本协议。<br>
          </div>
        </div>

        <div class="p-item">
          <div class="p-name">1、服务条款的确认和接纳</div>
          <div class="p-content">
            上上签由深圳市六六六国际旅行社有限公司运营，用户按照注册页面提示填写信息、阅读同意本协议且完成全部注册程序，或以上上签允许的其他方式成为上上签用户，即表示用户已知晓并同意按照本服务条款就使用上上签提供的服务与深圳市六六六国际旅行社有限公司达成具有法律约束力的协议。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">2、服务提供</div>
          <div class="p-content">
            2.1 上上签通过国际互联网络为用户提供的具体服务内容，由上上签根据实际情况提供。服务内容包括但不限于提供信息资讯、销售商品或服务等，上上签提供的部分服务由具有相应资质的第三方提供，内含免费服务内容及收费服务内容。上上签对其所提供的产品/服务内容拥有最终解释权。<br>
            2.2 为使用上述服务，用户必须自行配备访问国际互联网所需软硬件设备（例如电脑、手机、以及其他接入互联网或移动互联网有关的设备等）并承担相关费用（例如为接入互联网而支付的电话费、宽带费、上网费、手机费等）。 <br>
            2.3 若您勾选并购买了拒签无忧服务，表示您已仔细阅读并接受了拒签保障的赔付规则；即当您所购买的签证产品遭到拒签，您应于拒签之日起30日内通过上上签提交赔付申请，赔付金额以购买时的规则进行核算为准；若您未在30日内申请赔付的，则视为您自愿放弃该赔付权益。 <br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">3、用户权责</div>
          <div class="p-content">
            3.1 用户有权按照上上签的指引使用上上签提供的各项产品/服务，如果用户对产品/服务有异议，可以与上上签联系以便得到解决。<br>3.2 用户承诺其为具有完全民事行为能力的民事主体，且具有达成交易履行其义务的能力。<br>3.4用户有义务在使用签证、邮寄服务或反馈意见、投诉举报时提供自己的真实资料，保证上上签的工作人员可以通过上述联系方式与用户取得联系。<br>3.5 用户在使用上上签的服务时，需提供详尽准确的其企业或个人资料以及其客户的个人资料（以下统称为“个人资料”或“个人信息”），并若个人资料有任何变动，应及时更新个人资料，否则，由此引起的一切后果，例如邮寄错误、拒签或无法获得签证等等后果，由用户自行承担，若同时存在给其他用户造成签证困难或损失、或其他违法行为，上上签有权对您的帐号进行暂时性或永久性封禁。<br>3.6 用户通过上上签下载、使用的任何素材及其他上上签信息内容，仅限用户个人娱乐、学习、研究或者欣赏使用，未经上上签书面同意，不可用于任何商业用途。同时，用户承诺未经上上签事先书面同意，不得利用本服务进行广告、销售、商业展示等商业性用途。如果上上签发现用户利用本服务进行以上行为，有权删除您上传的内容，或对您的帐号进行暂时性或永久性封禁。<br>3.7 用户通过使用上上签的过程中所制作、上传、复制、发布、传播的任何内容，包括但不限于文字、图片、图文等发送、回复和相关链接页面，以及其他使用上上签所产生的内容，不得违反国家相关法律制度，包含但不限于如下原则：<br>（1）反对宪法所确定的基本原则的；<br>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>（3）损害国家荣誉和利益的；<br>（4）煽动民族仇恨、民族歧视，破坏民族团结的；<br>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；<br>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；<br>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>（8）侮辱或者诽谤他人，侵害他人合法权益的；<br>（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；<br>（10）以非法民间组织名义活动的；<br>（11）含有法律、行政法规禁止的其他内容的。<br>3.8  用户不得利用上上签的帐号或服务制作、上传、复制、发布、传播干扰上上签的正常运营，以及侵犯其他用户或第三方合法权益的内容，包括但不限于：<br>（1）含有任何性或性暗示的；<br>（2）含有辱骂、恐吓、威胁内容的；<br>（3）含有骚扰、垃圾广告、恶意信息、诱骗信息的；<br>（4）涉及他人隐私、个人信息或资料的；<br>（5）侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；<br>（6）含有不安全信息，其表现可能包括但不限于含钓鱼网站链接的相关内容；含木马或其他病毒网站链接及相关内容；含潜在危险、窃取用户隐私等相关内容；影响用户体验或被大量用户举报的未经审核的外链、二维码及其他多媒体等内容。<br>（7）含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。<br>3.9  用户应当遵守《中华人民共和国民法通则》、《中华人民共和国著作权法》、《中华人民共和国保守国家秘密法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《最高人民法院关于审理涉及计算机网络著作权纠纷案件适用法律若干问题的解释(法释[2004]1号)》、《互联网著作权行政保护办法》、《互联网新闻信息服务管理规定》、《中华人民共和国网络安全法》等有关国家法律、法规。在任何情况下，如用户违反国家法律法规或本协议条款，上上签有权对您的帐号进行暂时性或永久性封禁，若导致上上签遭受任何损害或遭受任何来自第三方的纠纷、诉讼、索赔要求等，用户须赔偿上上签所遭受的全部损失。<br>3.10 用户在使用上上签产品/服务时，如有退改情况，按<span class="highlight" @click="showBalanceUsageDialog = true;">《使用说明》</span>处理。《使用说明》是本协议不可分割的组成部分，与本协议具有同等法律效力。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">4、用户协议的修改</div>
          <div class="p-content">
            上上签有权根据运营需要随时对用户协议进行修改，修改后的用户协议，上上签将以适当的方式向用户提示。用户也可以随时登录上上签查阅最新的用户协议。用户如果不同意用户协议的修改，可以主动取消或放弃已经获得的产品/服务；如果用户继续享用产品/服务，则视为用户已经接受用户协议的修改。 <br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">5、服务的变更、中止或终止</div>
          <div class="p-content">
            上上签提供的软件及相关服务是按照现有技术和条件所能达到的现状提供的。上上签会尽最大努力向您提供服务，确保服务的连贯性和安全性。但为了整体服务运营、平台运营安全的需要，上上签有权视具体情况决定上上签的服务/功能的设置及其范围修改、中断、中止或终止软件及相关服务。上上签将尽量在变更、中断或终止服务之前事先以公告、系统弹窗等形式通知用户，尽量减小因此给用户造成的影响。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">6、知识产权声明</div>
          <div class="p-content">
            上上签对所提供的网络服务及网络服务所使用的软件系统（包含受知识产权或其他法律保护的资料）享有相应的权利。 <br>上上签自带的任何资讯及内容，包括所有版本、技术、程序、素材、界面和标示等内容，受到著作权法、商标法、专利法或其他法律的保护；未经上上签明示授权许可，用户不得进行修改、复制、再造或衍生其他作品或产品。用户不得对上上签软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble），或以其他方式发现其原始编码，以及实施任何涉嫌侵害著作权的行为。<br>上上签的名称、标志、图片以及上上签上的其他内容，均由上上签或相关内容提供方享有知识产权。未经上上签合法书面授权，任何人不得使用、复制或用作其他用途。 <br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">7、用户信息保护</div>
          <div class="p-content">
            我们会尽最大努力保护用户的个人信息安全。我们将严格按照本协议和《隐私政策》的规定收集、使用、存储、管理和保护用户的个人信息，请您仔细阅读《隐私政策》的内容，若您对《隐私政策》的全部或部分条款有疑问或意见，请及时联系我们。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">8、用户的账号，密码和安全性</div>
          <div class="p-content">
            8.1 用户注册后将获得上上签的账号及密码或验证码，用户应当妥善账号及密码和验证码并对任何人通过您的设备或账号进行的行为负责。因用户保管不善可能导致遭受盗号或密码或验证码失窃，责任由用户自行承担。用户若发现任何非法使用用户账号或安全漏洞，应立即通告上上签。<br>8.2 用户不得以任何形式擅自转让或授权他人使用自己的上上签账户，无论是通过有偿或无偿的方式，否则上上签有权对您的帐号进行暂时性或永久性封禁，并向您主张损害赔偿。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">9、违约责任</div>
          <div class="p-content">
            如果上上签发现或收到他人举报用户有违反本协议任何行为的， 上上签有权视其行为性质，对用户采取包括但不限于暂停或终止服务、追究用户的法律责任等措施。若因用户违反本协议导致任何损害的,用户应当独立承担责任并依法进行赔偿。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">10、不可抗力及其它免责声明</div>
          <div class="p-content">
            10.1 用户通过本服务收到广告信息，进而与第三方服务商进行任何形式的商业往来，或参与促销活动，包含相关商品或服务之付款及交付，以及达成的其他任何相关条款、条件、保证或声明，完全为您与第三方服务商之间的行为，相应的功能和服务由该第三方独立运营并独立承担全部责任。除有关法律有明文规定要求上上签承担责任以外，用户因前述任何交易或前述第三方服务商而遭受的任何性质的损失或损害，上上签均不予负责。<br>10.2 因本服务涉及到互联网及移动通讯等服务，可能会受到各个环节不稳定因素的影响。因此服务可能存在因计算机病毒或黑客攻击、电信/网络故障、GSM网络、第三方服务器故障、政府行为、战争、罢工和自然灾害等不可抗力，以及用户终端系统不稳定、用户所在位置或关机等原因造成的服务中断或不能满足用户要求的风险，或可能造成服务取消或终止的风险（您在本服务中储存的任何信息可能无法恢复），使用本服务的用户须自行承担以上风险。<br>10.3 因上述不可抗力和免责事由给您造成损失的，上上签在法律与政策允许的范围内免责。但若出现上述状况，上上签将尽快在能力范围内进行补救，尽量避免损失进一步扩大。<br>10.4  在任何情况下，上上签均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害承担责任，包括因您使用上上签及相关服务而遭受的利润损失。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">11、联系方式</div>
          <div class="p-content">
            如果您对本协议或服务内容有任何疑问、意见、建议或进行申诉，您可与专属客服咨询电话、质量监督电话、客服邮箱<span class="email">service@11visa.com</span>联系我们，我们将及时解决您的问题。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">12、法律适用及争议解决</div>
          <div class="p-content">
            12.1 本协议签订地为中华人民共和国广东省深圳市南山区。<br>12.2 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。<br>12.3 若您和上上签之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">13、其他</div>
          <div class="p-content">
            13.1 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。<br>13.2 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。<br>
          </div>
        </div>
      </div>
      <div class="text-content" v-show="to === 'privicy'">
        <div class="release-time">发布日期:2019年12月7日      更新时间:2020年6月4日</div>

        <div class="p-item">
          <div class="p-content">
            上上签由深圳市六六六国际旅行社有限公司（以下简称“六六六”）开发、运营。上上签非常尊重并保护所有使用服务用户的隐私权。为了给您提供更准确、更有个性化的服务，上上签会按照本隐私政策的规定使用和披露您的企业/个人信息。但上上签将以高度的勤勉、审慎义务对待这些信息。除本隐私政策另有规定外，在未征得您事先许可的情况下，上上签不会将这些信息对外披露或向第三方提供。<br>
            随着上上签服务范围的扩大，隐私条款的内容由六六六随时更新，且毋须另行通知。更新后的隐私声明一旦公布即有效代替原来的隐私声明。 您在同意上上签用户协议之时，即视为您已经同意本隐私政策全部内容。本隐私政策属于上上签服务使用协议不可分割的一部分。<br>
            如果您对我们的隐私政策有任何的疑问或建议，请联系：<span class="email">service@11visa.com</span>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">一、我们收集信息的范围、目的和方式</div>
          <div class="p-content">
            1.1 在您注册上上签帐号时，您根据上上签要求提供的手机号码、旅行社/门店名称、申请人姓名、邮箱、企业地址、名片等企业/个人注册信息（以下企业和个人信息统称为“个人信息”），我们将予以收集，收集这些信息是为了帮助您形成自己的帐号、不会与其他用户混淆、排查产品故障、保护您的帐号安全；<br>
            1.2 在您使用上上签网络服务，或访问上上签平台网页时，上上签自动接收并记录的您的移动端、浏览器和计算机上的信息，包括但不限于您的设备型号、配置信息、IP地址、浏览器的类型、使用的语言、访问日期和时间、地理位置信息、软硬件特征信息及您需求的网页记录等数据，收集这些信息是为了向您提供合适的语言服务及最近或最便利的相关产品/服务；<br>
            1.3 当您使用上上签的产品/服务时，您至少需要提供联系人姓名、联系电话、常用邮箱、详细地址的信息。当您使用签证产品/服务时，为给您或您的客户顺利办理签证，按照办签国或地区的规定，需要您提供客户的姓名、护照首页、证件照、身份证、社保证明、资产证明、银行卡流水或财产证明、人物关系证明信息等等，具体的信息根据不同的办签国或地区的最新要求最终确定；当您使用国际汽车驾驶执照的产品/服务时，为给您或您的客户顺利办理驾照，根据具体国家或地区的规定，需要您提供照片、身高、驾驶证等信息，具体的信息根据具体的国家或地区的最新要求最终确定；当您使用公证认证的产品/服务时，根据公证处的规定，需要您提供申请人身份证正反面、《出生医学证明》、户口本、申请人父母/亲属关系人身份证正反面、申请人父母/亲属关系人户口本和结婚证、申请哪个国家签证、翻译什么语言、户籍等等信息，具体的信息根据具体公证认证的类型和公证处的最新要求最终确定。我们收集这些信息，是为了向您提供相应的产品/服务，进行数据分析以提升产品/服务的安全性和可靠性，并为您提供管理您帐号的功能，例如：订单管理、修改个人设置、添加旅客信息、支付管理、订单评价等，同时，根据具体的情况，用于处理相关的保险索赔和付款。<strong>为便于您及您的客户多次申请，我们将储存您所提供的个人信息，当您为您的客户再次申请时，可以选择是否使用上一次的个人信息予以复用。</strong><br>
            1.4 如果您需要开具纸质或电子发票，您还需要提供包括发票抬头、邮箱等等在内的开票信息以及收件人、手机号、配送地址信息。<br>
            1.5 为了快捷、便利地向您提供相关的服务，我们在您同意拍照或上传相关证件图片时，可能需要您：<br>
            （1）开通终端系统的相机权限，用于拍摄；<br>
            您了解并同意，以下信息不适用本隐私权政策：<br>
            （2）使用终端系统的相册/储存权限，用于读取和存储照片；<br>
            （3）采用图片识别功能对证件图片进行识别使用。除用于您所确认的产品/服务、法律法规规定需要披露以及国家行政机关、司法机关要求出示以外，上上签对证件图片采取保密措施且不另作他用。<br>
            1.6 在您向我们提供您的客户的个人信息之前，您确保您已经取得该客户本人的同意，并确保其已知晓并接受本隐私政策。您所提供的您的客户的个人信息，我们均视为您的个人信息，按本隐私政策收集、保护和处理。<br>
            1.7 当您向我们提起意见反馈、投诉或进行咨询时，为了方便与您联系或帮助您解决问题，我们可能需要您提供姓名、手机号码、邮箱地址及其他联系方式等个人信息。如您拒绝提供上述信息，我们可能无法向您及时反馈的意见、投诉或咨询结果。<br>
            1.8 我们可能通过第三方间接获取您的用户标识信息，您使用第三方帐号（支付宝、微信、银行APP）登录本产品/服务时，我们可能读取并获得该第三方平台提供的用户标识信息。<br>
            1.9 我们会在得到您的同意后收集和使用您的个人信息以实现本产品相应的功能，并允许您对这些个人信息的收集与使用做出不同意的选择，但是拒绝使用这些信息会影响您使用相应的功能。<br>
            1.10 我们可能提供接入其他第三方APP的广告合作或跳转服务，请您务必在使用其他第三方APP前仔细阅读第三方的用户协议和隐私政策，确认后再使用，证件照随拍不会收集和存储您在使用第三方APP时被第三方收集的个人信息。<br>
            1.11 根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息，无需征求您的授权同意：<br>
            （1) 与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等重大公共利益直接相关的；<br>
            （2) 与犯罪侦查、起诉、审判和判决执行等直接相关的；<br>
            （3) 出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；<br>
            （4) 所收集的个人信息是您自行向社会公众公开的；<br>
            （5) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；<br>
            （6) 根据您要求签订和履行合同所必需的；<br>
            （7) 用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br>
            （8) 为开展合法的新闻报道所必需的；<br>
            （9) 出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br>
            （10) 法律法规规定的其他情形。<br>
            1.12请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在本隐私政策中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。<br>
            1.13如未来为业务发展需要从其他第三方间接获取您个人信息，我们会在获取前向您明示您个人信息的范围、目的和方式。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">二、我们如何保护您的个人信息</div>
          <div class="p-content">
            2.1技术措施与数据安全措施<br>
            2.1.1我们努力采取各种符合业界标准的物理、电子和管理方面的安全措施来保护您的个人信息安全，以防止您的个人信息遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。<br>
            2.1.2我们通过与信息接触者签署保密协议和监控机制来对数据进行全面安全控制，以防止您的个人信息遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。<br>
            2.1.3我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们承诺将使您的个人信息存储时间始终处于法律要求或实现产品功能和服务所需的合理必要的期限内。对于超出期限的个人信息，我们会立即删除或做匿名化处理。<br>
            2.2安全事件处理<br>
            我们将尽力确保您发送给我们的任何信息的安全性，但请您理解，由于技术的限制以及在互联网行业可能存在的各种恶意手段，互联网并非百分之百安全的环境。您需要了解，您接入我们服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。为防止安全事故的发生，我们制定了妥善的预警机制和应急预案。若不幸发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议和对您的补救措施，并立即启动应急预案，力求将损失最小化。我们将及时将事件相关情况以电话、推送通知等方式告知您，难以逐一告知用户时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况，紧密配合政府机关的工作。<br>
            2.3您的个人信息存储<br>
            我们将从中华人民共和国境内获得的信息存放于中华人民共和国境内。如果发生数据的跨境传输，我们会单独向您以弹窗或邮件的方式告知您数据出境的目的、接收方等，并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。<br>
            当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">三、我们如何共享、转让、公开披露您的个人信息</div>
          <div class="p-content">
            3.1 除非事先得到您的许可，否则上上签不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，但下列情形除外：<br>（1）上上签（含上上签关联公司）可能与合作伙伴单独或共同为您提供产品/服务，需要共享您的个人信息，包括快递业务、通讯服务等等。<br>（2）您主动公开分享、共享信息：通过由我们或第三方提供的功能，您可以主动公开分享、共享信息（如向其他互联网平台转发内容），在这种情况下共享信息将被广泛并即时传送。但只要您不删除被共享的信息，该信息会一直留存在公众领域；在一些情况下，即使您删除共享信息，该等信息仍可由其他用户或与我们没有关联及不受我们控制的第三方独立地缓存、复制或储存，或通过其他用户或该等第三方在公众领域保存。<br>（3）我们可能会根据法律法规的规定、诉讼、争议解决的需要、或按政府主管部门或司法机关依法提出的强制性要求，对外共享您的个人信息。<br>（4）在法律法规要求或允许的范围内，为保护您、其他用户或社会公众利益、财产或安全免遭损害而由必要提供您的个人信息给第三方。<br>（5）当您提交订单、申请退款时，我们会与金融机构或第三方支付机构共享特定的订单信息；当我们认为用于欺诈检测和预防欺诈等有实属必要性时，我们将进一步与相关金融机构或第三方支付机构共享您的其他必要的信息，例如IP地址等。<br>（6）在上上签平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，上上签有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。<br><br>3.2除非获取您的明确同意或根据适用的法律法规的规定或司法要求，我们不会将您的个人信息转让给任何公司、组织或个人，但下列情形除外：<br>（1）随着我们业务的持续发展，我们有可能进行合并、收购、资产转让、清算等交易，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司/组织，按照法律法规及不低于本隐私政策所要求的标准继续保护或要求新的控制者继续保护您的个人信息，否则，我们要求该公司/组织重新征求您的授权同意。<br>3.3我们不会对外公开披露其收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意，但根据法律法规的规定、诉讼、争议解决的需要、或按政府主管部门或司法机关依法提出的强制性要求，我们可能会公开披露您的个人信息。<br>3.4共享、转让、公开披露个人信息授权同意的例外<br>根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下共享、转让、公开披露您的个人信息：<br>（1） 与国家安全、国防安全有关的；<br>（2） 与公共安全、公共卫生、公众知情、重大公共利益直接有关的；<br>（3） 与犯罪侦查、起诉、审判和判决执行等直接有关的；<br>（4） 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br>（5） 您自行向社会公众公开的个人信息；<br>（6） 根据您签订和履行合同所必需的；<br>（7） 用于维护所提供的产品/服务的安全稳定运行所必需的，例如发现、处理产品/服务的故障；<br>（8） 出于公共利益开展统计或学术研究所必要的，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行匿名化或去标识化处理的；<br>（9）从合法公开披露的信息中收集到的个人信息，如合法的新闻报道、政府信息公开等渠道。<br>（10） 法律法规规定的其他情形。<br>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">四、个人信息存储和交换</div>
          <div class="p-content">
            上上签在中华人民共和国境内运营中收集的有关您的信息和资料将保存在中国国内的上上签及（或）其关联公司的服务器上，但如下情形除外：<br>（1）法律法规有明确规定；<br>（2）获得您的明确授权；<br>（3）当您预订的产品/服务涉及境外供应商提供服务时。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">五、您的权利</div>
          <div class="p-content">
            在您使用我们的产品/服务期间，您可以访问、更正、删除您的个人信息，同时您享有撤回对个人信息使用的同意及注销帐号的权利此外，我们还设置了投诉举报渠道，您的意见将会得到及时的处理。<br>5.1您有权随时访问和更正您的个人信息，包括联系人姓名、手机号码、常用邮箱、所在地区、详细地址等。<br>5.2如果您已完成了签证需求，主动要求删除已完成的签证信息或其他个人信息，您可以与我们的客服联系提出删除个人信息的请求，您的删除请求一旦被响应，我们将在15个工作日内删除系统内您的个人信息，同时还将通知从上上签获得您个人信息的第三方实体（例如使用本产品作为第三方登录账号的其他互联网平台），要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。<br>5.3您随时可以与我们的客服联系提出注销帐号的请求，我们将在15个工作日内删除或匿名化处理您的个人信息。<br>5.4 如果您希望撤回您的授权，可通过与我们的客服联系，我们将在收到您的请求后15个工作日内处理您的请求。但请您理解并同意，当您撤回某些授权时，将导致与之相应的产品功能不可用，我们无法继续为您提供撤回同意或授权所对应的特定功能/服务，并且您撤回授权的决定不会影响此前基于您的授权而开展的个人信息处理。<br>5.5 为保障安全，我们可能会先要求您验证自己的身份，然后再处理您的请求。<br>5.6 根据相关法律法规的规定，以下情形我们将无法响应您的请求：<br>（1） 与国家安全、国防安全有关的；<br>（2） 与公共安全、公共卫生、公众知情、重大公共利益直接有关的；<br>（3） 与犯罪侦查、起诉、审判和判决执行等直接有关的；<br>（4）有充分证据表明您存在主观恶意或滥用权利的；<br>（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<br>（6）涉及商业秘密的。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">六、Cookie的使用</div>
          <div class="p-content">
            Cookie是网页服务器放在您访问设备上的文本文件，会帮助您在后续访问时调用信息，简化记录您填写个人信息的流程。您有权接受或拒绝Cookie。如果浏览器自动接受Cookie，您可以根据自己的需要修改浏览器的设置以拒绝Cookie。请注意，如果您选择拒绝Cookie，那么您可能无法完全体验上上签提供的产品/服务。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">七、个人敏感信息</div>
          <div class="p-content">
            个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。本隐私政策中涉及的个人敏感信息包括：个人财产类信息（包括银行账号、口令、资产证明信息、房产信息、交易和消费记录、流水记录）、个人健康医疗信息、个人身份信息（包括身份证、护照、社保卡、居住证、台胞证、回乡证、军人证、驾驶证、户口簿、出生证明、外国人永久居留身份证、港澳台居民居住证、照片、婚姻证明、关系证明、在职证明、单位证明）、网络身份标识信息（包括用户名、系统账号、邮箱地址、以及与前述有关的密码、口令、口令保护答案）、以及其他信息（包括个人电话号码、婚史、行踪轨迹、住宿信息、精准定位信息、种族信息、宗教信息）。这些个人敏感信息将受到严格保护。上上签在此提醒您，您在使用上上签为您提供的产品/服务中所上传或发布的内容和信息可能会披露您的个人敏感信息，因此，您需要在使用我们为您提供的产品/服务前谨慎考虑。您同意这些个人敏感信息将按照本隐私政策阐明的目的和方式来进行处理。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">八、未成年人保护</div>
          <div class="p-content">
            我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用我们的产品/服务前，应事先取得您的家长或法定监护人的书面同意。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">九、变更</div>
          <div class="p-content">
            我们可能会适时对本隐私政策进行修订。当隐私政策的条款发生变更时，我们会在您登录及版本更新时以推送通知、弹窗的形式向您展示变更后的隐私政策。请您注意，只有在您点击弹窗中的同意按钮后，我们才会按照更新后的指引收集、使用、存储您的个人信息。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">十、与我们联系</div>
          <div class="p-content">
            当您有投诉、建议、处理个人信息、未成年人个人信息相关问题时，请通过专属客服咨询电话、质量监督电话、客服邮箱<span class="email">service@11visa.com</span>联系我们，我们将及时解决您的问题。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">十一、适用法律及管辖</div>
          <div class="p-content">
            本隐私政策适用中华人民共和国大陆地区的法律。本隐私政策项下的争议由被告所在地的人民法院管辖。<br>
          </div>
        </div>
        <div class="p-item">
          <div class="p-name">十二、其他</div>
          <div class="p-content">
            本隐私政策是我们统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用于所有我们的用户。本隐私政策未规定事项适用本产品/服务的用户协议。<br>
          </div>
        </div>
      </div>
    </div>

    <!-- 使用说明 -->
    <balance-usage
      v-show="showBalanceUsageDialog"
      @close="showBalanceUsageDialog = false">
    </balance-usage>
  </div>
</template>
<script>
import balanceUsage from '../user/user-children/components/balance-usage';

export default {
  name: 'privacy-policy',
  components: {
    balanceUsage,
  },
  data() {
    return {
      to: this.$route.params.to,
      showBalanceUsageDialog: false,
    };
  },
};
</script>
<style lang="less" scoped>
#privacy-policy {
  background-color: white;
  width: 1000px;
  margin: 40px auto 60px auto;
  display: flex;
  flex-direction: column;
  .top-nav {
    border-bottom: 1px solid #E9EEF2;
    height: 60px;
    display: flex;
    align-items: center;
    padding-left: 48px;
    .top-nav-item {
      margin-right: 64px;
      font-size: 16px;
      line-height: 22px;
      color: #91999F;
      font-weight: 400;
      position: relative;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all .2s;
      &.active {
        color: #599FFF;
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        &::before {
          content: "";
          width: 26px;
          height: 3px;
          background-color: #599FFF;
          border-radius: 2px;
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
        }
      }
    }
  }
  .bottom-content {
    display: flex;
    flex-direction: column;
    .text-content {
      display: flex;
      flex-direction: column;
      padding: 24px 24px 48px 24px;
      .release-time {
        color: #91999F;
        font-size: 14px;
        line-height: 20px;
      }
      .p-item {
        margin-top: 24px;
        display: flex;
        flex-direction: column;
        .p-name {
          font-size: 16px;
          line-height: 22px;
          color: #2F333D;
          font-weight: 600;
        }
        .p-content {
          margin-top: 2px;
          font-size: 12px;
          line-height: 24px;
          color: #2F333D;
          .email, .highlight {
            color: #599FFF;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/privicy/PrivacyPolicy.vue